export const routes = [
  {
    path: '/:platformKey',
    /* internal name: '/[platformKey]' */
    /* no component */
    children: [
      {
        path: '',
        name: '/[platformKey]/',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/index.vue'),
        /* no children */
      },
      {
        path: 'comments',
        /* internal name: '/[platformKey]/comments' */
        /* no component */
        children: [
          {
            path: ':path(.*)?',
            name: '/[platformKey]/comments/[[...path]]',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/comments/[[...path]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dms',
        /* internal name: '/[platformKey]/dms' */
        /* no component */
        children: [
          {
            path: ':path(.*)?',
            name: '/[platformKey]/dms/[[...path]]',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/dms/[[...path]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'posts',
        /* internal name: '/[platformKey]/posts' */
        /* no component */
        children: [
          {
            path: '',
            name: '/[platformKey]/posts/',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/posts/index.vue'),
            /* no children */
          },
          {
            path: ':folder',
            /* internal name: '/[platformKey]/posts/[folder]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/[platformKey]/posts/[folder]/',
                component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/posts/[folder]/index.vue'),
                /* no children */
              },
              {
                path: ':postId',
                name: '/[platformKey]/posts/[folder]/[postId]',
                component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/posts/[folder]/[postId].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'watchlists',
            /* internal name: '/[platformKey]/posts/watchlists' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/[platformKey]/posts/watchlists/[id]',
                component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/posts/watchlists/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'tweets',
        /* internal name: '/[platformKey]/tweets' */
        /* no component */
        children: [
          {
            path: ':folder?',
            name: '/[platformKey]/tweets/[[folder]]',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/tweets/[[folder]].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'userlist',
        /* internal name: '/[platformKey]/userlist' */
        /* no component */
        children: [
          {
            path: '',
            name: '/[platformKey]/userlist/',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/userlist/index.vue'),
            /* no children */
          },
          {
            path: ':folder',
            /* internal name: '/[platformKey]/userlist/[folder]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/[platformKey]/userlist/[folder]/',
                component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/userlist/[folder]/index.vue'),
                /* no children */
              },
              {
                path: ':userId',
                /* internal name: '/[platformKey]/userlist/[folder]/[userId]' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/[platformKey]/userlist/[folder]/[userId]/',
                    component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/userlist/[folder]/[userId]/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'comments',
                    name: '/[platformKey]/userlist/[folder]/[userId]/comments',
                    component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/userlist/[folder]/[userId]/comments.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'watchlists',
            /* internal name: '/[platformKey]/userlist/watchlists' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/[platformKey]/userlist/watchlists/[id]',
                component: () => import('/home/runner/work/Frontend/Frontend/src/pages/[platformKey]/userlist/watchlists/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('/home/runner/work/Frontend/Frontend/src/pages/admin.vue'),
    /* no children */
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'callback',
        name: '/auth/callback',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/auth/callback.vue'),
        /* no children */
        meta: {
          "isPublic": true
        }
      },
      {
        path: 'facebook',
        /* internal name: '/auth/facebook' */
        /* no component */
        children: [
          {
            path: '',
            name: '/auth/facebook/',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/auth/facebook/index.vue'),
            /* no children */
          },
          {
            path: 'apptoken',
            name: '/auth/facebook/apptoken',
            component: () => import('/home/runner/work/Frontend/Frontend/src/pages/auth/facebook/apptoken.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'login',
        name: '/auth/login',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/auth/login.vue'),
        /* no children */
        meta: {
          "isPublic": true
        }
      }
    ],
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dashboard/',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/dashboard/index.vue'),
        /* no children */
      },
      {
        path: ':blockedUsers',
        name: '/dashboard/[blockedUsers]',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/dashboard/[blockedUsers].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/privacy',
    name: '/privacy',
    component: () => import('/home/runner/work/Frontend/Frontend/src/pages/privacy.vue'),
    /* no children */
    meta: {
      "isPublic": true
    }
  },
  {
    path: '/statistics',
    /* internal name: '/statistics' */
    /* no component */
    children: [
      {
        path: '',
        name: '/statistics/',
        component: () => import('/home/runner/work/Frontend/Frontend/src/pages/statistics/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/terms',
    name: '/terms',
    component: () => import('/home/runner/work/Frontend/Frontend/src/pages/terms.vue'),
    /* no children */
    meta: {
      "isPublic": true
    }
  }
]
